/**
 * @packageDocumentation
 * Module for managing browser history.
 *
 * This wraps `history.createBrowserHistory` and exports a singleton
 * that can be used across the app to navigate programmatically.
 */
import { createBrowserHistory } from 'history';

export default createBrowserHistory();